var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{attrs:{"id":'cb' + _vm.id,"switch":""},on:{"change":function($event){return _vm.billTask()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }